import moment from 'moment';
import { HiddenProperty, Model } from './Model';
import { User } from './User';
import { TicketType } from '@app/websocket/models/TicketType';

export enum TicketStatus {
    BACKLOG = 'Backlog',
    AGUARDANDO_ANALISE = 'Analise',
    EM_DESENVOLVIMENTO = 'Sendo_Trabalhado',
    EM_TESTES = 'Homologacao',
    AGUARDANDO_INFORMACOES = 'Aguardando_Cliente',
    DOCUMENTACAO = 'Documentacao',
    FINALIZADO = 'Finalizado'
}

export class TicketSalesforce extends Model<TicketSalesforce> {
    // tslint:disable: variable-name
    /**
     * @deprecated
     */
    Id: string;
    /**
     * @deprecated
     */
    Name: string;
    /**
     * @deprecated
     */
    Abertura__c: string;
    /**
     * @deprecated
     */
    Tipo_Servico__c: string;
    /**
     * @deprecated
     */
    Fechamento__c: string;
    /**
     * @deprecated
     */
    Previsao_Solucao__c: string;
    /**
     * @deprecated
     */
    Responsavel_Processo_Atendimento__c: string;
    /**
     * @deprecated
     */
    Status_Ativacao__c: string;
    /**
     * @deprecated
     */
    Status_Atual__c: TicketStatus;
    /**
     * @deprecated
     */
    Texto_Abertura__c: string;
    /**
     * @deprecated
     */
    Texto_Solucao__c: string;
    /**
     * @deprecated
     */
    SubProcesso__c: string;
    /**
     * @deprecated
     */
    Nome_Empresa__c: string;
    /**
     * @deprecated
     */
    Email_Cliente__c: string;

    @HiddenProperty('Id')
    public id: string;

    @HiddenProperty('Name')
    public name: string;

    @HiddenProperty('Abertura__c')
    public openingDate: string;

    @HiddenProperty('Tipo_Atendimento__c')
    public serviceType: string;

    @HiddenProperty('Fechamento__c')
    public closingDate: string;

    @HiddenProperty('Previsao_Solucao__c')
    public expectedSolutionDate: string;

    @HiddenProperty('Responsavel_Processo_Atendimento__c')
    public assignedTo: string;

    @HiddenProperty('Texto_Abertura__c')
    public content: string;

    @HiddenProperty('Texto_Solucao__c')
    public solution: string;

    @HiddenProperty('SubProcesso__c')
    public subProcess: string;

    @HiddenProperty('Nome_Empresa__c')
    public companyName: string;

    @HiddenProperty('Email_Cliente__c')
    public clientEmail: string;

    @HiddenProperty('Tela_avaliacao__c')
    public origin: string;

    @HiddenProperty('Contabilidade__c')
    public accountancy: string;

    @HiddenProperty('Produto__c')
    public product: string;

    @HiddenProperty('NPS__r')
    public nps?: string;

    public get icon() {
        let icon: string = null;
        switch (this.Status_Atual__c) {
            case TicketStatus.BACKLOG:
                icon = 'fad fa-face-sleeping';
                break;
            case TicketStatus.AGUARDANDO_ANALISE:
                icon = 'fad fa-hourglass-half';
                break;
            case TicketStatus.EM_DESENVOLVIMENTO:
                icon = 'fad fa-screwdriver-wrench';
                break;
            case TicketStatus.EM_TESTES:
                icon = 'fad fa-microscope';
                break;
            case TicketStatus.AGUARDANDO_INFORMACOES:
                icon = 'fad fa-messages-question';
                break;
            case TicketStatus.DOCUMENTACAO:
                icon = 'fad fa-book';
                break;
            case TicketStatus.FINALIZADO:
                icon = 'fad fa-badge-check';
                break;
            default:
                icon = 'fa fa-hashtag';
                break;
        }
        return icon;
    }

    public get typeIcon() {
        let typeIcon: string = null;
        switch (this.serviceType) {
            case TicketType.DUVIDA:
                typeIcon = 'fas fa-question';
                break;
            case TicketType.BUGFIX_lower:
                typeIcon = 'fas fa-triangle-exclamation';
                break;
            case TicketType.BUGFIX_upper:
                typeIcon = 'fas fa-triangle-exclamation';
                break;
            case TicketType.MELHORIA:
                typeIcon = 'fas fa-lightbulb';
                break;
            case TicketType.MAPEAMENTO_PLANILHA:
                typeIcon = 'fas fa-file-spreadsheet';
                break;
        }
        return typeIcon;
    }

    public get labelBackgroundColor() {
        let color: string = null;
        switch (this.Status_Atual__c) {
            case TicketStatus.BACKLOG:
            case TicketStatus.AGUARDANDO_ANALISE:
                color = 'bg-light';
                break;
            case TicketStatus.AGUARDANDO_INFORMACOES:
                color = 'bg-warning text-light';
                break;
            case TicketStatus.EM_DESENVOLVIMENTO:
                color = 'bg-success text-light';
                break;
            case TicketStatus.DOCUMENTACAO:
            case TicketStatus.EM_TESTES:
                color = 'bg-primary text-light';
                break;
            case TicketStatus.FINALIZADO:
                color = 'bg-dark text-light';
                break;
            default:
                color = 'bg-secondary';
                break;
        }
        return color;
    }

    public get isRatedClass() {
        let color: string = 'fal';
        if (this.nps) {
            color = 'fas';
        }
        return color;
    }

    public get productBackgroundColor() {
        switch (this.product) {
            case 'Tareffa': return '#4b4279';
            case 'Atendimento ao Cliente': return '#ec5b88';
            case 'Integrador': return '#004ecb';
            case 'Busca-Extrato': return '#ff8a00';
            case 'Bussola': return '#0e0f52';
            default: return '#004ecb';
        }
    }

    public get narration() {
        const dataAbertura = moment(this.Abertura__c).format('DD/MM/YYYY');
        const nomeEmpresa = this.Nome_Empresa__c.split('-')[1].split(' | ')[0].trim();
        return `Chamado criado por ${this.Email_Cliente__c} em ${dataAbertura} para a empresa ${nomeEmpresa}: ${this.Texto_Abertura__c}. Situação atual: ${this.status}`;
    }

    public get status() {
        switch (this.Status_Atual__c) {
            case TicketStatus.AGUARDANDO_ANALISE: return ' Em análise';
            case TicketStatus.AGUARDANDO_INFORMACOES: return ' Aguardando informações';
            case TicketStatus.EM_DESENVOLVIMENTO: return ' Sendo trabalhado';
            case TicketStatus.EM_TESTES: return ' Em teste de qualidade';
            case TicketStatus.DOCUMENTACAO: return ' Documentação';
            case TicketStatus.FINALIZADO: return ' Finalizado';
            default: return this.Status_Atual__c;
        }
    }

}

export class TicketItem extends Model<TicketItem> {

    /**
     * @deprecated
     */
    public Atendimento__c: string;
    /**
     * @deprecated
     */
    public Data_Movimento__c: string;
    /**
     * @deprecated
     */
    public Descricao__c: string;
    /**
     * @deprecated
     */
    public Movimento_Liberado__c: boolean;
    /**
     * @deprecated
     */
    public Origem__c: 'Cliente' | 'Ottimizza';
    /**
     * @deprecated
     */
    public Processo__c: string;
    /**
     * @deprecated
     */
    public Responsavel__c: string;
    /**
     * @deprecated
     */
    public Status_Movimento__c: TicketStatus;
    /**
     * @deprecated
     */
    public Status_Ativacao__c: string;
    /**
     * @deprecated
     */
    public Tipo_Movimento__c: string;
    /**
     * @deprecated
     */
    public Link_Arquivo: string;

    @HiddenProperty('Atendimento__c')
    public ticketId: string;

    @HiddenProperty('Data_Movimento__c')
    public date: string;

    @HiddenProperty('Descricao__c')
    public description: string;

    @HiddenProperty('Movimento_Liberado__c')
    public isReleased: boolean;

    @HiddenProperty('Origem__c')
    public from: 'Cliente' | 'Ottimizza';

    @HiddenProperty('Processo__c')
    public process: string;

    @HiddenProperty('Responsavel__c')
    public assignedTo: string;

    @HiddenProperty('Status_Movimento__c')
    public status: TicketStatus;

    @HiddenProperty('tipoMovimento__c')
    public type: string;

    @HiddenProperty('Link_Arquivo')
    public file?: string;

    public get narration(): string {
        const origem = this.Origem__c === 'Cliente' ? User.fromLocalStorage().organization.name : this.Origem__c;
        const dataMovimento = moment(this.Data_Movimento__c).format('DD/MM/YYYY');
        return `${origem} disse em ${dataMovimento}: ${this.Descricao__c}`;
    }

}
